import React from "react";
import Img from "../../../assets/logo.webp";
import ImgBlue from "../../../assets/logo_blue.webp";

import { Box } from "@mui/material";

type LogoProps = {
  width: number;
  height: number;
  blue?: boolean;
};

const Logo: React.FC<LogoProps> = ({ width, height, blue }) => (
  <Box
    sx={{
      m: "0 auto",
      width: `${width}px`,
      height: `${height}px`,
      backgroundSize: "contain",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundImage: blue ? `url(${ImgBlue})` : `url(${Img})`,
    }}
  />
);

export default Logo;
